/* global Swiper */
// *******************************************************************************
//  Timeline slider
// *******************************************************************************

const timelineMainSlider = document.querySelectorAll('[data-slider="timeline-main-slider"]');
const timelineThumbSlider = document.querySelectorAll('[data-slider="timeline-thumb-slider"]');

// *******************************************************************************
// 1.1 - Timeline Thumb Slider
// *******************************************************************************

const timelineThumbSliderOptions = {
  slidesPerView: 3,
  spaceBetween: 5,
  speed: 600,
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  observer: true,
  observeParents: true,
  breakpoints: {
    1023: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
};

timelineThumbSlider.forEach((el) => new Swiper(el, timelineThumbSliderOptions));

// *******************************************************************************
// 1.2 -Timeline Main Slider
// *******************************************************************************

const timelineMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 300,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

timelineMainSlider.forEach((el, i) => {
  const timelineMainSliderParent = el.closest('.sc-timeline');
  const arrowRight = timelineMainSliderParent.querySelector('.arrow-right');
  const arrowLeft = timelineMainSliderParent.querySelector('.arrow-left');

  timelineMainSliderOptions.navigation.nextEl = arrowRight;
  timelineMainSliderOptions.navigation.prevEl = arrowLeft;

  timelineMainSliderOptions.thumbs.swiper = timelineThumbSlider[i].swiper;

  // eslint-disable-next-line no-new
  new Swiper(el, timelineMainSliderOptions);
});
